/** Тексты пространства «user». Ключи именуются по смыслу, а не по месту. */
export const user = {
  /* ── Общее для экранов аккаунта ──────────────────────────────────────── */

  field: {
    role: 'Роль',
  },

  /** Знак состояния аккаунта: стоит и в списке, и в карточке участника. */
  state: {
    revoked: 'доступ снят',
    deleted: 'данные удалены',
    readOnly: 'только чтение',
  },

  value: {
    vkId: 'id {{id}}',
  },

  /* ── Профиль ─────────────────────────────────────────────────────────── */

  profile: {
    title: 'Профиль',

    section: {
      account: 'Аккаунт',
      registryLink: 'Ссылка на профиль в реестре',
    },

    guestRole: 'Гость: без доступа к записи',
    registryLinkIntro:
      'Реестр открыт любому пользователю ВК, даже если его нет в списке участников. В карточке персонажа стоит ссылка на вашу страницу — по ней видно, кто за него играет.',

    hide: {
      label: 'Скрывать ссылку на мой профиль в реестре',
      on: 'Сейчас ссылки в карточке нет: читатели видят персонажа, но не видят, кто им играет',
      off: 'Сейчас ссылка видна: любой, кто открыл карточку персонажа, попадёт по ней на вашу страницу',
      scope:
        'Скрывается только ссылка. Персонаж, его анкета, склад и питомцы остаются в реестре как были. Администрация и модераторы по-прежнему видят, чей это персонаж, — иначе разбирать заявки было бы невозможно.',
    },

    loading: 'Читаем настройку',
    saveError: 'Настройка не сохранилась',

    locked: {
      title: 'Настройка пока недоступна',
      guest:
        'Вашей страницы нет среди участников с доступом, поэтому настройку здесь не изменить. Если персонажа у вас не было, ссылке в реестре взяться неоткуда. Если доступ сняла администрация, а персонаж остался, убрать его из реестра вместе со ссылкой можно в разделе «Удалить мои данные» — или попросить об этом администрацию.',
      readOnly:
        'Запись закрыта, поэтому настройку сейчас не изменить. Если ссылку нужно убрать прямо сейчас, напишите администрации проекта или удалите персонажа вместе с ней в разделе «Удалить мои данные».',
      deleted:
        'Вы удалили свои данные, поэтому настройку сейчас не изменить. Персонажа у вас больше нет, так что и ссылке на вашу страницу в реестре взяться неоткуда. Настройка вернётся вместе с правом записи.',
    },
  },

  /* ── Админка: каркас и вайтлист ──────────────────────────────────────── */

  admin: {
    title: 'Админка',
    userTitle: 'Участник',
    noAccess: 'Административные разделы открыты модераторам анкет и суперадминам.',

    section: {
      config: 'Настройки',
      audit: 'Журнал',
    },

    roleFilterAll: 'Все роли',
  },

  whitelist: {
    titleCount: 'Участники · {{total}}',

    searchPlaceholder: 'имя, заметка или id',
    readOnlyHint: 'У вашего аккаунта снято право записи.',

    empty: {
      title: 'Никого не нашли',
      text: 'Проверьте написание или добавьте аккаунт кнопкой «Добавить».',
    },

    openRow: 'Открыть участника: {{name}}',
  },

  /* ── Карточка участника ──────────────────────────────────────────────── */

  card: {
    self: 'это вы',

    fact: {
      vkId: 'Числовой id ВК',
      revokedAt: 'Доступ снят',
      deletedAt: 'Данные удалены',
      createdAt: 'В списке с',
      registryProfile: 'Профиль в реестре',
      registryHidden: 'скрыт',
      registryVisible: 'виден',
    },

    section: {
      roleAndNote: 'Роль и заметка',
      access: 'Доступ',
    },

    hint: {
      roleSelf: 'Свою роль сменить нельзя — иначе легко остаться без единого суперадмина.',
      role: 'Модератор анкет разбирает очередь анкет, квест-мастер — предметы и способности.',
      note: 'Видна только администрации. Сюда обычно пишут, кто это и откуда.',
    },

    action: {
      revoke: 'Снять доступ',
      restore: 'Вернуть доступ',
    },

    accessNote:
      'Снятие доступа закрывает запись и ничего не удаляет: персонаж, его анкета и склад остаются в реестре как были. Персонажа это не трогает вовсе — убрать его можно только отдельно и осознанно.',
    selfRevokeNote: 'Снять доступ с самого себя нельзя.',

    saveError: 'Не сохранили',

    saved: {
      role: 'Роль изменена на «{{role}}».',
      note: 'Заметка сохранена.',
      /** Кнопка одна на оба поля, и сохранить их можно разом. */
      roleAndNote: 'Роль и заметка сохранены.',
      revoked: 'Доступ снят.',
      restored: 'Доступ вернули.',
    },

    confirm: {
      revoke: {
        title: 'Снять доступ?',
        text: 'Аккаунт останется в списке ради истории, но писать не сможет. Персонажа это не трогает: он и его анкета остаются в реестре.',
      },
      restore: {
        title: 'Вернуть доступ?',
        text: 'Аккаунт снова сможет вести персонажа и склад.',
        textDeleted:
          'Аккаунт снова сможет завести персонажа и вести склад, а отметка об удалении данных снимется. Прежнего персонажа это не вернёт: игрок удалил его сам.',
      },
    },
  },

  /* ── Добавление в вайтлист ───────────────────────────────────────────── */

  add: {
    title: 'Новый участник',

    field: {
      vkId: 'Числовой id страницы ВК',
      displayName: 'Как подписать',
    },

    hint: {
      vkId: 'Короткое имя пользователь может сменить в любой момент, и запись перестанет соответствовать живому человеку. Числовой id виден в адресе вида vk.com/id123456789 и в настройках страницы.',
      role: 'Роль можно поменять позже в карточке участника.',
      displayName: 'Необязательно: имя для списка, чтобы не искать по цифрам.',
      note: 'Необязательно. Видна только администрации.',
    },

    placeholder: {
      vkId: '123456789',
      displayName: 'Имя или ник',
    },

    numericOnly: 'Только цифры. Короткое имя (vk.com/ivanov) не подойдёт.',

    error: 'Не добавили',
    added:
      'id {{id}} добавлен. Добавили не того? Снимите доступ в карточке участника — запись останется ради истории.',
  },

  /* ── Удаление своих данных ───────────────────────────────────────────── */

  deletion: {
    title: 'Удалить данные',

    section: {
      stored: 'Что приложение о вас хранит',
      removed: 'Что будет удалено',
      kept: 'Что останется',
      confirm: 'Подтверждение',
    },

    stored:
      'Если ваша страница есть в списке участников, приложение хранит её номер ({{id}}), роль и право записи. Имя в этом списке, если оно есть: при самостоятельной записи — и при возвращении после удаления данных — приложение берёт со страницы ВК имя и фамилию, больше ничего из профиля; в остальных случаях имя вписывает администратор. Заметку администрации о вас, если её оставили. Если вы удалили свои данные и ещё не вернулись в проект — отметку об этом с датой; в журнале она остаётся и после возвращения.\n\nВсё, что вы внесли сами: анкеты персонажа, предметы склада, питомцев, способности и загруженные изображения. Отметку о том, до какого места вы прочли ленту решений. Решения модерации по вашим заявкам и служебный журнал действий с вашим аккаунтом и персонажем. Паролей и переписки приложение не хранит.',

    guest: {
      title: 'Доступа к записи у вас нет',
      text: 'Если вас никогда не добавляли в список участников, приложение ничего о вас не хранит — на попытку удалить сервер так и ответит. Если доступ сняла администрация, персонаж и всё, что вы внесли, по-прежнему хранятся, а принятая анкета может стоять в реестре со ссылкой на вашу страницу. Удалить всё это можно здесь же — так же, как любому участнику.',
    },

    already: {
      title: 'Данные уже удалены',
      text: 'Вы удалили их {{date}}. С тех пор у приложения о вас только то, что перечислено в разделе «Что останется», — удалять больше нечего.',
    },

    nothing: {
      title: 'Удалять нечего',
      text: 'Вашей страницы нет в списке участников и никогда не было: ни персонажа, ни изображений, ни записей о вас у приложения нет. Сессия живёт только в памяти приложения и пропадёт, как только вы его закроете.',
    },

    removed: {
      characters: 'Ваш персонаж целиком — в том числе убранный в архив.',
      forms:
        'Все версии анкет — черновики, заявки на проверке, отклонённые и принятые, включая ту, что сейчас видна в реестре.',
      items: 'Предметы склада со всеми редакциями.',
      pets: 'Питомцы и их паспорта.',
      abilities: 'Способности и дебафы.',
      images:
        'Загруженные вами изображения — вместе с файлами в хранилище. Остаются только те, что стоят в базе внешек или в карточке персонажа, которого передали другому игроку.',
      readMarks: 'Отметка о том, до какого места вы прочли ленту решений.',
      access:
        'Право записи: отправлять анкету и вести склад станет нельзя, пока вы не вернётесь в проект.',
    },

    kept: {
      account:
        'Строка в списке участников: номер вашей страницы, имя, роль и заметка администрации, если её оставили, — и отметка об удалении данных с датой; она снимется, когда вы вернётесь в проект. На строку ссылается служебный журнал. Вернуться можно самим, если в проекте открыта самостоятельная запись: во вкладке «Персонаж» будет кнопка «Присоединиться». Если запись закрыта, право записи вернёт администрация.',
      ban: 'Снятый администрацией доступ, если его сняли: удаление данных этого не отменяет. Самостоятельной записью такой доступ не вернуть — только через администрацию.',
      audit:
        'Служебный журнал: когда вас внесли в список участников и кто менял вам роль, доступ или заметку, что происходило с персонажем (вид, общежитие, класс, передача, архив), и отметка о самом удалении. В записях имя и заметка такие, какими были в тот момент. Журнал не правится задним числом: по нему разбирают спорные ситуации. Текстов анкеты и имущества в нём нет.',
      decisions:
        'Решения модерации по вашим заявкам: вердикт, дата и комментарий проверяющего. К персонажу они больше не привязаны, но в самом комментарии его имя могло остаться. Это история работы модераторов, и она сохраняется.',
      mentions:
        'Записи чужих персонажей, где вы упоминались текстом, — их пишут другие игроки, и удалить их за них приложение не может.',
      staff:
        'Если вы входили в администрацию — ваши решения по чужим заявкам, заведённые вами внешки и записи журнала о ваших действиях. Это общая работа проекта, и вместе с вашими данными она не удаляется. Роль тоже остаётся — и сейчас, и когда вы вернётесь в проект. Пока её не сменит суперадмин, разделы, открытые вашей роли, — очереди заявок, журнал, а у суперадмина и список участников — останутся доступны для чтения; принимать решения и что-либо править без права записи нельзя.',
    },

    /** Что делать дальше, зависит от записи и от бана: сессия после удаления перезапущена. */
    done: {
      title: 'Данные удалены',
      open: 'Удалено всё из раздела «Что будет удалено». Реестр и база внешек по-прежнему открыты для чтения — как любому гостю. Вернуться можно самим, когда захотите: во вкладке «Персонаж» есть кнопка «Присоединиться». Персонажа придётся завести заново.',
      closed:
        'Удалено всё из раздела «Что будет удалено». Реестр и база внешек по-прежнему открыты для чтения — как любому гостю. Самостоятельная запись сейчас закрыта: чтобы снова завести персонажа, напишите администрации. Если запись откроют, во вкладке «Персонаж» появится кнопка «Присоединиться».',
      revoked:
        'Удалено всё из раздела «Что будет удалено». Реестр и база внешек по-прежнему открыты для чтения — как любому гостю. Доступ к аккаунту раньше сняла администрация, и удаление этого не изменило: вернуть его может только она.',
    },

    warning: {
      title: 'Отменить будет нельзя',
      text: 'Восстановить удалённую анкету не сможет даже администрация: резервной копии на этот случай не предусмотрено. Если вы просто хотите сделать паузу — напишите администрации, удалять ничего не придётся.',
    },

    agree:
      'Я понимаю, что персонаж, все версии анкеты, склад, питомцы, способности и мои изображения будут удалены безвозвратно',

    action: 'Удалить мои данные',

    confirm: {
      title: 'Удалить все данные?',
      text: 'Персонаж, все версии анкеты, склад, питомцы, способности и ваши изображения будут удалены без возможности восстановления.\n\nЭто последнее подтверждение.',
      action: 'Да, удалить',
    },
  },
} as const;
